import { useEffect, useMemo } from 'react';
import { shallowEqual } from 'react-redux';
import { getText } from 'i18n/intl';
import {
  availabilityCollectionLoadingSelector,
  availabilityCollectionSettingsSelector,
  fetchExamV3ReservationSettings,
  saveExamV3ReservationSettings,
  update,
} from 'slices/availabilityCollectionSettings.slice';
import { availabilityReservationModesSelector } from 'slices/reservationMode.slice';
import { selectedReservationTemplateByResModeId } from 'slices/reservationTemplate.slice';
import { useAppDispatch, useAppSelector } from 'slices/store';
import type { TAvailabilityCollectionSettings } from 'types/availabilityCollectionSettings.type';
import { Button, TEInput } from '@timeedit/ui-components';
import { Space } from '@timeedit/ui-components/antd';

const ReservationMapping = () => {
  const dispatch = useAppDispatch();
  const availabilityCollectionSettings = useAppSelector(
    availabilityCollectionSettingsSelector
  );
  const availabilityReservationModes = useAppSelector(
    availabilityReservationModesSelector,
    shallowEqual
  );

  const availabilityReservationTemplates = useAppSelector(
    selectedReservationTemplateByResModeId(
      availabilityCollectionSettings.reservationMode
    ),
    shallowEqual
  );

  const isLoading = useAppSelector(availabilityCollectionLoadingSelector);

  useEffect(() => {
    dispatch(fetchExamV3ReservationSettings());
  }, []);

  const options = useMemo(() => {
    return availabilityReservationModes.map((mode) => ({
      label: mode.name,
      value: mode.id,
    }));
  }, [availabilityReservationModes]);

  const tempOptions = useMemo(() => {
    return availabilityReservationTemplates.map((mode) => ({
      label: mode.name,
      value: mode.id,
    }));
  }, [availabilityReservationTemplates]);

  const onChange = (value: Partial<TAvailabilityCollectionSettings>) => {
    dispatch(update(value));
  };

  return (
    <Space direction="vertical" style={{ width: 'fit-content' }}>
      <TEInput.Select
        size="middle"
        style={{ width: 200 }}
        options={options}
        label={getText(
          'availability_collection.reservation_mapping.reservation_mode_select'
        )}
        value={availabilityCollectionSettings.reservationMode}
        onChange={(value) => onChange({ reservationMode: value })}
      />
      <TEInput.Select
        size="middle"
        style={{ width: 200 }}
        options={tempOptions}
        label={getText(
          'availability_collection.reservation_mapping.reservation_template_select'
        )}
        value={availabilityCollectionSettings.reservationTemplate}
        onChange={(value) => onChange({ reservationTemplate: value })}
      />
      <TEInput.Select
        size="middle"
        style={{ width: 200 }}
        options={[
          { label: 'AVAILABILITY', value: 'AVAILABILITY' },
          { label: 'UNAVAILABILITY', value: 'UNAVAILABILITY' },
        ]}
        onChange={(value) =>
          onChange({
            availabilityType: value as 'AVAILABILITY' | 'UNAVAILABILITY',
          })
        }
        value={availabilityCollectionSettings.availabilityType}
        label={getText(
          'availability_collection.reservation_mapping.availability_type'
        )}
      />
      <Button
        type="primary"
        style={{ float: 'right' }}
        loading={isLoading}
        onClick={() => dispatch(saveExamV3ReservationSettings())}
      >
        Save Changes
      </Button>
    </Space>
  );
};

export default ReservationMapping;
